import { Injectable } from "@angular/core";
import { TradeTypes } from "./globals.service";

@Injectable({
  providedIn: "root",
})
export class PopupService {
  public specialPopups: Array<SpecialPopup> = [];

  private standardPopupOpen: boolean = false;
  private standardPopTitle: string = "";
  private standardPopContent: string = "";
  private standardPopupButtons: Array<PopupButton> = [];

  constructor(public tradeTypes: TradeTypes) {
    this.specialPopups.length = 0;

    Object.keys(SpecialPopupType)
      .filter((k) => typeof SpecialPopupType[k as any] === "number")
      .forEach((type) => {
        this.specialPopups.push(new SpecialPopup(SpecialPopupType[type]));
      });
  }

  public open(
    title: string,
    content: string,
    buttons: Array<PopupButton> = null
  ) {
    this.standardPopTitle = title;
    this.standardPopContent = content;

    if (buttons == null) {
      this.standardPopupButtons.push(
        new PopupButton("Close", "", () => {
          this.close();
        })
      );
    } else {
      this.standardPopupButtons = buttons;
    }

    this.standardPopupOpen = true;
  }

  public close() {
    this.standardPopTitle = "";
    this.standardPopContent = "";
    this.standardPopupButtons.length = 0;
    this.standardPopupOpen = false;
  }

  public getSpecialPopup(type: SpecialPopupType): SpecialPopup {
    var ret: SpecialPopup = null;

    this.specialPopups.forEach((p) => {
      if (p.type == type) {
        ret = p;
      }
    });

    return ret;
  }

  public openRedirectPopup(redirectPopupType: ExternalRedirectPopupType, redirectURL: string) {
    var p = this.getSpecialPopup(SpecialPopupType.ConfirmRedirectToExternalURL);
  
    if (p != null) p.open = true;
    p.redirectURL = redirectURL;
    p.redirectMessage = this.getExternalRedirectMessage(redirectPopupType);
  }

  public getExternalRedirectMessage(redirectPopupType: ExternalRedirectPopupType): string {
    switch (redirectPopupType) {
      case ExternalRedirectPopupType.RedirectToMovingService:
        return `You are being redirected to Smart Express website. Please read their privacy policy before submitting your personal data.`;
      case ExternalRedirectPopupType.RedirectToHRV:
        return `You are being redirected to the HRV website. Please read their privacy policy before submitting your personal data.`;
      case ExternalRedirectPopupType.RedirectToChemDryService:
        return `You are being redirected to Chem Dry website. Please read their privacy policy before submitting your personal data.`;
      default:
        return `You are being redirected to a third party website. Please read their privacy policy before submitting your personal data.`;
    }
  }

  public openSpecialPopup(
    type: SpecialPopupType,
    redirectURL: string = "",
    tradeTypeID: number = null
  ) {
    var p = this.getSpecialPopup(type);

    if (p != null) p.open = true;

    if (redirectURL) p.redirectURL = redirectURL;

    if (tradeTypeID) p.tradeTypeID = tradeTypeID;
  }

  public triggerExternalRedirect(popupType: SpecialPopupType) {
    var p = this.getSpecialPopup(popupType);
    if (p && p.redirectURL) window.open(p.redirectURL);
  }

  public closeSpecialPopup(type: SpecialPopupType) {
    var p = this.getSpecialPopup(type);

    if (p != null) {
      p.open = false;
    }
  }

  public getHTMLContentForTradeTypeInformationPopup(): TradeTypeInformationPopupContent {
    var p = this.getSpecialPopup(SpecialPopupType.TradeTypeInformation);
    const tradeTypeID = p.tradeTypeID;

    var popupContent = new TradeTypeInformationPopupContent(
      "UNKNOWN TRADE TYPE",
      "No additional information has been loaded for this trade type. Sorry about that :(",
      []
    );

    switch (tradeTypeID) {
      case this.tradeTypes.Plumbing:
        popupContent = new TradeTypeInformationPopupContent(
          "Plumbing - Information",
          "Some of our plumbing installation and repair services include:",
          [
            "Dishwasher installation",
            "Toilet installation",
            "Vanity installation",
            "General plumbing maintenance",
          ]
        );
        break;
      case this.tradeTypes.Electrical:
        popupContent = new TradeTypeInformationPopupContent(
          "Electrical - Information",
          "Some of our electrical installation services include:",
          [
            "Oven installation",
            "Installing new lighting - including LED upgrades, dimmers, and security lighting",
            "Power point installations",
            "Installing extractor fan",
            "Switchboard upgrades, including RCD protection",
          ]
        );
        break;
      case this.tradeTypes.HVAC:
        popupContent = new TradeTypeInformationPopupContent(
          "Air Con / Heat Pump - Information",
          "Our air con / heat pump services include:",
          ["Installation", "Maintenance / Cleaning", "Repair services"]
        );
        break;
      case this.tradeTypes.GutterCleaning:
        popupContent = new TradeTypeInformationPopupContent(
          "Gutter Cleaning - Information",
          "todo",
          []
        );
        break;
      case this.tradeTypes.Locksmith:
        popupContent = new TradeTypeInformationPopupContent(
          "Locksmith - Information",
          "Some of our locksmith services include:",
          [
            "Lock-picking and unlocking services",
            "Extracting broken keys",
            "Re-keying and key duplication",
            "Installing window locks or deadlocks",
          ]
        );
        break;
      case this.tradeTypes.Handyman:
        popupContent = new TradeTypeInformationPopupContent(
          "Handyperson - Information",
          "Some of our handyperson services include:",
          [
            "Repairing or replacing damaged drywall",
            "Patching and painting walls",
            "Staining and varnishing surfaces",
            "Installing hooks, window latches, or locks",
            "Installing towel rails",
            "Miscellaneous jobs",
          ]
        );
        break;
      case this.tradeTypes.AAHealthyHomeInspection:
        popupContent = new TradeTypeInformationPopupContent(
          "Home Inspections - Information",
          "Our home inspection services include:",
          [
            "Healthy Home Inspections",
            "Pre-Purchase/Sale Building Inspections",
            "Rental Property Inspections",
            "Methamphetamine Testing",
            "Asbestos Testing",
          ]
        );
        break;
        case this.tradeTypes.AAFlatPackAssembly:
          popupContent = new TradeTypeInformationPopupContent(
            "Flatpack Assembly - Information",
            "Some of our assembly services include:",
            [
              "Barbecues",
              "Garden sheds",
              "Trampolines",
              "Greenhouses",
              "Outdoor and indoor furniture",
              "Fitness equipment",
            ]
          );
          break;

          case this.tradeTypes.MovingService:
            popupContent = new TradeTypeInformationPopupContent(
              "Moving In/Out - Information",
              "Our moving in/out services include:",
              [
                "House and apartment moves",
                "Intercity moves",
                "Supply of packing materials",
                "Office moves",
              ]
            );
          break;

          case this.tradeTypes.CarpetCleaningService:
            popupContent = new TradeTypeInformationPopupContent(
              "Carpet Cleaning - Information",
              "Our carpet cleaning services include:",
              [
                'Carpet Cleaning',
                'Specialty Stain Removal',
                'Specialty Rug Cleaning',
                'Sanitise, Deodorise and Protect',
                'Pet Urine and Odour Removal',
                'Leather Cleaning',
                'Upholstery Cleaning',
                'Tile and Grout Cleaning',
                'Mould Removal and Remediation',
                'Trauma and Biohazard Cleaning',
                'Flood and Water Restoration',
                'Fire and Smoke Restoration',
              ]
            );
          break;

      default:
        break;
    }

    return popupContent;
  }
}

export class TradeTypeInformationPopupContent {
  public title: string = "";
  public bodyContent: string = "";
  public jobTypeNames: string[] = [];

  constructor(title: string, bodyContent: string, jobTypeNames: string[]) {
    this.title = title;
    this.bodyContent = bodyContent;
    this.jobTypeNames = jobTypeNames;
  }
}

export class PopupButton {
  public text: string = "";
  public classes: string = "standardButton buttonPointer";
  public callback: () => void = null;

  constructor(
    text: string,
    classes: string,
    callback: () => void = null,
    replaceClasses: boolean = false
  ) {
    this.text = text;
    this.classes = replaceClasses == true ? classes : this.classes + classes;
    this.callback = callback;
  }

  public onClick() {
    if (this.callback != null) {
      this.callback();
    }
  }
}

export class SpecialPopup {
  public type: SpecialPopupType;
  public open: boolean = false;
  
  public tradeTypeID: number = null; // for info popup

  // for SpecialPopupType.ConfirmRedirectToExternalURL
  public redirectURL: string = ``; 
  public redirectMessage: string = ``;
  constructor(type: SpecialPopupType) {
    this.type = type;
  }
}


export enum SpecialPopupType {
  Unknown = -1,
  TermsAndConditions = 0,
  PrivacyPolicy = 1,
  FAQ = 2,
  ContactUs = 3,
  ConfirmRedirectToExternalURL = 4,
  TradeTypeInformation = 5,
}

export enum ExternalRedirectPopupType {
  RedirectGeneric = 1,
  RedirectToHRV = 2,
  RedirectToMovingService = 3,
  RedirectToChemDryService = 4,
}



